import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import * as moment from 'moment';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { map } from 'rxjs/operators';

import { AgendamentoService } from '@app/shared/services';
import { MensagemService } from '@app/shared/services/mensagem.service';
import { GerenciarAgendamentoService } from '@app/shared/services/gerenciar-agendamento.service';

import { Loading } from '@app/shared/models';

import { environment } from '@environments/environment';

@Component({
  selector: 'app-cadastrar-agendamento',
  templateUrl: './cadastrar-agendamento.component.html',
  styleUrls: ['./cadastrar-agendamento.component.scss']
})
export class CadastrarAgendamentoComponent implements OnChanges {

  @Input('censo') censo: any;
  @Input('usuario') usuario: any;

  cliente = environment.cliente;
  dataAtual: Date = new Date();
  form: FormGroup = new FormGroup({});
  carregar = new Loading();
  dataEscolhida: Date;
  dataInicial: Date;
  minDate: Date;
  maxDate: Date;

  dataAtualUTC: string = moment(new Date()).format('YYYY-MM-DD');
  horarioAtualUTC: string = new Date().getHours() + ':' + new Date().getMinutes();

  horarios: any[] = [];
  horarioSelecionado: any;
  locais: any;

  constructor(
    private agendamentoService: AgendamentoService,
    private formBuilder: FormBuilder,
    public gerenciarAgendamentoService: GerenciarAgendamentoService,
    private mensagemService: MensagemService
  ) {
    moment.locale('pt-BR');
    this.form = this.formBuilder.group({
      local: [null, Validators.required],
      dataAgendamento: [moment(new Date()).format('YYYY-MM-DD'), Validators.required],
      idHorario: [null, Validators.required],
      cpf: [null, Validators.required],
      usuario: [null, Validators.required],
      contatoPrimario: [null, Validators.required],
      email: [null],
      idCenso: this.cliente.censo_id
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.gerenciarAgendamentoService.status === 'AGENDAR') {
      this.buscarLocaisAtendimento();
    }
  }

  abrirLocalizacao(): void {
    window.open(`https://www.google.com.br/maps/search/${encodeURI(this.form.get('local').value?.endereco)}`, '_blank').focus();
  }

  selecionarLocal(localSelecionado: any): void {
    this.form.patchValue({
      local: localSelecionado.value,
      horario: null
    });

    this.agendamentoService.listarDatas(this.censo.id, localSelecionado.value.id, this.carregar)
      .pipe(
        map(items => items.filter(item => item.data >= this.dataAtualUTC && item.hora >= this.horarioAtualUTC))
      ).subscribe(data => {
        if (data.length > 0) {
          this.dataInicial = this.minDate = this.dataAtual;
          this.maxDate = this.converterData(data[data.length - 1].data);
        }
      }, (error) => {
        return this.mensagemService.avisoMensagemError(error);
      });
  }

  selecionarData(event: any): void {
    this.dataEscolhida = event;

    this.form.patchValue({
      dataAgendamento: this.dataEscolhida,
      data: moment(new Date(this.dataEscolhida)).format('YYYY-MM-DD'),
      horario: null
    });

    this.agendamentoService.listarHorarios(
      this.censo.id, this.form.get('local')?.value?.id,
      moment(new Date(this.dataEscolhida)).format('YYYY-MM-DD'),
      this.carregar
    ).subscribe(data => {
      this.horarios = data
    }, (error) => {
      return this.mensagemService.avisoMensagemError(error);
    });
  }

  selecionarHorario(horario: any): void {
    this.horarioSelecionado = horario;

    this.form.patchValue({
      dataAgendamento: horario.data,
      idHorario: horario.id
    });
  }

  filtraDatas = (d: Date): boolean => {
    const day = d.getDay();
    return day !== 0 && day !== 6;
  }

  buscarLocaisAtendimento(): void {
    this.agendamentoService.listarLocais(
      this.censo.id,
      this.carregar
    ).subscribe(data => {
      this.locais = data
    }, (error) => {
      return this.mensagemService.avisoMensagemError(error);
    });
  }

  converterData(data: string): Date {
    return new Date(`${data}T00:00:00`);
  }

  submitForm(): void {
    this.form.patchValue({
      cpf: this.usuario.cpf,
      usuario: this.usuario.id
    });

    if (this.form.invalid) {
      return this.mensagemService.avisoMensagemAlerta('Selecione o local, a data, o horário e informe um número de telefone para contato.');
    }

    Swal.fire({
      title: 'Atenção',
      html: `
          <br>
          <b>Confira as informações do agendamento</b><br><br>
          <b>Local:</b> ${this.form.get('local')?.value.nome} <br/>
          <b>Data:</b> ${moment(this.form.get('dataAgendamento')?.value).format('DD/MM/YYYY')} às ${this.horarioSelecionado.hora}
        `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Agendar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.agendamentoService.agendar(this.form.value, this.carregar).subscribe(() => {
          Swal.fire(
            'Sucesso!',
            'Seu agendamento foi realizado',
            'success'
          ).then(response => {
            if (response.isConfirmed) {
              this.gerenciarAgendamentoService.atualizarStatus('AGENDAMENTOS');
            }
          });
        });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        return;
      }
    });
  }

}

